import { r as registerInstance, f as createEvent, h, e as Host, g as getElement } from './index-6c727dca.js';

const epiToggleChoiceCss = ".epi-toggle-choice{position:relative;cursor:pointer;display:-ms-inline-flexbox;display:inline-flex;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;background:var(--white);color:var(--richBlack);font-weight:700;height:54px;width:98px;overflow:visible}.epi-toggle-choice:first-of-type{border-radius:6px 0 0 6px}.epi-toggle-choice:last-of-type{border-radius:0 6px 6px 0}@media (max-width: 720px){.epi-toggle-choice{width:72px}}.epi-toggle-choice+.epi-toggle-choice{border-left:1px solid var(--grey, #b2b2b2)}.epi-toggle-choice--selected{background:var(--brandSecondary);color:var(--white)}.epi-toggle-choice__popular{position:absolute;top:100%;margin:2px 0 0;font-size:15px;color:var(--brandSecondary);white-space:nowrap}@media screen and (max-width: 474px){.epi-toggle-choice.epi-toggle-choice{border:1px solid var(--grey);border-radius:6px;margin-bottom:24px}.epi-toggle-choice.epi-toggle-choice:not(:last-of-type){margin-right:1%}}";

const EpiToggleChoice = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.selection = createEvent(this, "epi-toggle_selectionChange", 7);
    this.klassName = `epi-toggle-choice`;
    /**
     * Whether or not the item is selected
     * @internal
     */
    this.selected = false;
    /** Whether or not this is a popular option */
    this.popular = false;
    /**
     * The value of the option that is displayed to the user
     * @internal
     */
    this.viewValue = this.el.textContent;
  }
  handleSelection() {
    this.selection.emit(this.value);
  }
  handleKeydown(ev) {
    switch (ev.key) {
      case `Enter`:
      case ` `:
        ev.preventDefault();
        this.handleSelection();
        break;
      default:
        break;
    }
  }
  /** NOTE: Possibly need a `setValue` Method to allow for interaction with CVAs in angular */
  /**
   * Lifecycle hooks in the order that they are called. Uncomment to use
  */
  // componentWillLoad() { }
  // componentDidLoad() { }
  // componentWillRender() { }
  // componentDidRender () { }
  // componentDidRender() { }
  // componentWillUpdate() { }
  // componentDidUpdate() { }
  /**
   * The render() function should always be the last one in the class
  */
  render() {
    return (h(Host, { class: `
          ${this.klassName}
          ${this.selected ? `epi-toggle-choice--selected` : ``}
        `, "aria-pressed": `${this.selected}`, tabindex: "0", role: "button", onClick: () => this.handleSelection(), onKeydown: ev => this.handleKeydown(ev) }, h("slot", null), this.popular
      ? h("p", { class: `${this.klassName}__popular` }, "Most Popular")
      : null));
  }
  get el() { return getElement(this); }
};
EpiToggleChoice.style = epiToggleChoiceCss;

export { EpiToggleChoice as epi_toggle_choice };
